<template>
  <div class="sfmy">
    <div class="headimg">
      <img src="../../../assets/img/common/mybg.png" />
    </div>
    <div class="header">
      <div class="sp1"></div>
      <div class="headercenter">
        <div class="imgcon"><img src="../../../assets/img/common/head.png" /></div>
        <div class="headertext">
          <div class="top">{{subdata.mobile}}</div>
        </div>
      </div>
      <div class="info" @click="gotoInfo">
        个人信息<van-icon name="arrow" />
      </div>
    </div>
    <div class="btncon">
      <div class="item" @click="jumpMyExpress">
        <div class="top">
          <img src="../../../assets/img/common/express.png" />
        </div>
        <div class="bottom">我的快递</div>
      </div>
      <div class="item" @click="gotoAddress">
        <div class="top">
          <img src="../../../assets/img/common/address.png" />
        </div>
        <div class="bottom">地址簿</div>
      </div>
      <div class="item" @click="openKf">
        <div class="top">
          <img src="../../../assets/img/common/kefu.png" />
        </div>
        <div class="bottom">客服中心</div>
      </div>
      <div class="item" @click="openFp">
        <div class="top">
          <img src="../../../assets/img/common/invoice.png" />
        </div>
        <div class="bottom">开发票</div>
      </div>
      <div class="item" @click="jumpCoupon">
        <div class="top">
          <img src="../../../assets/img/common/coupons.png" />
        </div>
        <div class="bottom">优惠券</div>
      </div>
    </div>
    <Footer :active="'my'"></Footer>
    <Kefu ref="kefu"></Kefu>
    <Fapiao ref="fapiao"></Fapiao>
  </div>
</template>

<script>
import Footer from '../components/footer'
import Kefu from '../components/kefu'
import Fapiao from '../components/fapiao'
import { personalInfo } from '@/api/modules/user'
export default {
  name: 'sfmy',
  components: {
    Footer, Kefu, Fapiao
  },
  data() {
    return {
      track: false,
      subdata: {
        sex: '',
        nname: '',
        mobile: ''
      }
    }
  },
  computed: {
  },
  created() {
    personalInfo().then((res) => {
      console.log(res)
      if (res.data.status_code === 200) {
        this.subdata.sex = res.data.person.sex
        this.subdata.nname = res.data.person.nname
        this.subdata.mobile = res.data.person.mobile
      }
    })
  },
  methods: {
    openKf() {
      this.$refs.kefu.openShadow()
    },
    openFp() {
      this.$refs.fapiao.openShadow()
    },
    gotoAddress() {
      this.$router.push('/sf/addresslist')
    },
    jumpMyExpress() {
      this.$router.push('/sf/search')
    },
    jumpCoupon() {
      this.$router.push('/sf/coupons')
    },
    gotoInfo() {
      this.$router.push('/sf/myinfo')
    }
  }
}
</script>

<style lang="less" scoped>
  .sfmy{
    width:100%;
    min-height:100vh;
    background-color: #F3F3F3;
    .sp1{
      height:30px;
    }
    .con{
      width:100%;
      height:300px;
      background-color:#ffffff;
    }
    .headimg{
      position:absolute;
      top:135px;
      width: 708px;
      height:272px;
      left:21px;
      img{
        display:block;
        width:100%;
        height:100%;
      }
    }
    .header{
      width: 708px;
      height: 319px;
      background: linear-gradient(96deg, #FEF6E1 0%, #FFFFFF 100%);
      border-radius: 15px;
      margin:0px auto;
      position:relative;
      z-index:3;
      .sp1{
        height:100px;
        width:100%;
      }
      .headercenter{
        height:120px;
        width:100%;
        .imgcon{
          margin-left:60px;
          width:120px;
          height:120px;
          background-color:#99F7FF;
          border-radius:120px;
          float:left;
          img{
            width:57px;
            height:auto;
            display:block;
            margin:0px auto;
            padding-top:15px;
          }
        }
        .headertext{
          float:left;
          width:300px;
          font-size:30px;
          padding-top:20px;
          margin-left:30px;
        }
      }
      .info{
        width: 128px;
        height: 42px;
        background: #202935;
        border-radius: 5px 5px 5px 0px;
        position:absolute;
        right:0px;
        top:50%;
        margin-top:-21px;
        font-weight: 500;
        font-size: 20px;
        color: #FEFEFE;
        line-height: 42px;
        padding-left:20px;
      }
    }
    .btncon{
      width: 708px;
      height: 164px;
      background: #FFFFFF;
      border-radius: 15px;
      margin:120px auto 0px auto;
      display:flex;
      .item{
        flex:1;
        text-align:center;
        img{
          width:50px;
          height:50px;
        }
        font-weight: 400;
        font-size: 24px;
        color: #000000;
        line-height: 31px;
        .top{
          margin-top:40px;
        }
      }
    }
  }
</style>
